module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAWlBMVEUAAAAAoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq8Aoq9bc40qAAAAHXRSTlMA9OtKKu/MbFnf2igUoZmPfU84Ht3Tv655YEJBDWLAeSgAAABpSURBVAjXTcpJDsMgAATBtgkQFu/Zk/n/NwMcLOoyUmtwduhYh15fc/p4oYXOKm4KB9DkuwKjd7rSbIo+oJ1FT4pJM0noDUbDkcd63Aba//eQXAZMC9U8UbRg6OwlrJcqpTZeRDt2bPwDVUwFnNtSsk0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email.png
// module id = maZZ
// module chunks = 1